ScrollTrigger.config({ ignoreMobileResize: true });

let tickers = document.querySelectorAll('.js-countdown');

const zeroPad = (num, places) => String(num).padStart(places, '0')

if (tickers) {
    var updateCountdowns = window.setInterval(function(){
        // call your function here
        tickers.forEach(ticker => {
            let date = ticker.dataset.date;
            var timer = moment(new Date(date)).countdown();

            let newTime = zeroPad(timer.days, 2) + ':' + zeroPad(timer.hours, 2) + ':' + zeroPad(timer.minutes, 2) + ':' + zeroPad(timer.seconds, 2);

            ticker.innerText = newTime;
        });


    }, 1000);
}

let transitionUp = document.querySelectorAll('.js-transition-up');

transitionUp.forEach((elem) => {

  let transitionUpAnim = gsap.timeline({paused: true})
  .to(elem, 1, { y: 0, ease: "sine.out"});

  ScrollTrigger.create({
      trigger: elem,
      start: "top 66%",
      once: true,
      onEnter: ({progress, direction, isActive}) => transitionUpAnim.play(),
      markers: false
  });

});


let fadeIn = document.querySelectorAll('.js-fade-in');

fadeIn.forEach((elem) => {

    let fadeInAnim = gsap.timeline({paused: true})
    .fromTo(elem, 1, { opacity: 0 }, {opacity: 1, ease: "sine.out"})

    ScrollTrigger.create({
        trigger: elem,
        start: "top 66%",
        once: true,
        onEnter: ({progress, direction, isActive}) => fadeInAnim.play(),
        markers: false
    });

});


let fadeInGroup = document.querySelectorAll('.js-fade-in-group');

fadeInGroup.forEach((elem) => {

  let group = elem.querySelectorAll('.js-fade-in-group-item');

    let fadeInAnim = gsap.timeline({paused: true})
    .staggerFromTo(group, 1, { opacity: 0 }, {opacity: 1, ease: "sine.out"}, 0.2)

    ScrollTrigger.create({
        trigger: elem,
        start: "top 66%",
        once: true,
        onEnter: ({progress, direction, isActive}) => fadeInAnim.play(),
        markers: false
    });

});

let newsletter = document.querySelector('.js-newsletter-form'),
    closeNewsletter = document.querySelector('.js-close-newsletter');

    newsletter && newsletter.classList.add('active')

if (closeNewsletter) {
    closeNewsletter.addEventListener("click", () => {
        newsletter && newsletter.classList.remove('active');
    });
}
